// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Slider/Slider.css
// module id = 1482
// module chunks = 0